/*
 * File: getInitials.ts
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */

/**
 * Generates initials from a person's first and last name.
 *
 * @param firstName - The person's first name
 * @param lastName - The person's last name
 * @returns Uppercase initials (e.g., "JD" for "John Doe")
 *
 * @example
 * getInitials('John', 'Doe') // 'JD'
 * getInitials('Jane', null) // 'J'
 * getInitials(null, 'Smith') // 'S'
 */
export function getInitials(firstName: string | null, lastName: string | null): string {
  const first = firstName?.charAt(0) || '';
  const last = lastName?.charAt(0) || '';
  return `${first}${last}`.toUpperCase();
}